import type { OrdersActions } from 'src/store/actions/widgets/orders';
import type { OrdersWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const ordersReducer = (
    state: WidgetTabViewModel<OrdersWidgetViewModel>,
    action: OrdersActions,
): WidgetTabViewModel<OrdersWidgetViewModel> => {
    switch (action.type) {
        case 'updateOrdersAccount': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    accountIds: action.accountId ? [action.accountId] : [],
                },
            };
        }

        case 'updateOrdersInstrument':
        case 'linkingUpdateOrdersInstrument': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    instrument: action.instrument,
                },
            };
        }

        case 'updateOrdersIsManualReviewSoundAlertEnabled': {
            if (state.widget.isManualReviewSoundAlertEnabled === action.isManualReviewSoundAlertEnabled) {
                return state;
            }

            return {
                ...state,
                widget: {
                    ...state.widget,
                    isManualReviewSoundAlertEnabled: action.isManualReviewSoundAlertEnabled,
                },
            };
        }

        default:
            return state;
    }
};
